import { DriverHaltsService, PouchesService } from '@/backend/market'
import { PouchRepository } from '../../domain/repositories/PouchRepository'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import { DriverPouchModel } from '../models/DriverPouchModel'
import type { DriverPouchEntity } from '../../domain/entities/DriverPouchEntity'
import type { PouchFilterEntity } from '../../domain/entities/PouchFilterEntity'
import { PouchFilterModel } from '../models/PouchFilterModel'
import type { DriverPouchMiniEntity } from '../../domain/entities/DriverPouchMiniEntity'
import { DriverPouchMiniModel } from '../models/DriverPouchMiniModel'
import type { AccountantPouchMiniEntity } from '../../domain/entities/AccountantPouchMiniEntity'
import { AccountantPouchMiniModel } from '../models/AccountantPouchMiniModel'
import type { AccountantPouchEntity } from '../../domain/entities/AccountantPouchEntity'
import { AccountantPouchModel } from '../models/AccountantPouchModel'
import type { DriverHaltsFilterEntity } from '../../domain/entities/DriverHaltsFilterEntity'
import { DriverHaltsFilterModel } from '../models/DriverHaltsFilterModel'
import { DriverHaltModel } from '../models/DriverHaltModel'
import type { DriverHaltEntity } from '../../domain/entities/DriverHaltEntity'
export class PouchRepositoryImpl implements PouchRepository {
  async getDriverPouches(
    filterData: PouchFilterEntity
  ): Promise<PaginateEntity<DriverPouchMiniEntity[]> | { error: true }> {
    const pouchFilterModel = new PouchFilterModel(filterData)
    try {
      const response = await PouchesService.getDriverPouchesAdmin(pouchFilterModel as {})
      const pouchModel = response.items?.map((item) => new DriverPouchMiniModel(item))
      const result = new PaginateEntity<DriverPouchMiniModel[]>(response, pouchModel)
      return result
    } catch {
      return { error: true }
    }
  }
  async exportDriverPouch(filterData: PouchFilterEntity): Promise<Blob | null | undefined> {
    const pouchFilterModel = new PouchFilterModel(filterData)
    try {
      const response = await PouchesService.exportDriverPouchFilesAdmin(pouchFilterModel as {})
      return response.file
    } catch {
      return null
    }
  }
  async getDriverPouch(id: number): Promise<DriverPouchEntity | { error: true }> {
    try {
      const response = await PouchesService.getDriverPouchAdmin({
        id
      })
      const pouchModel = new DriverPouchModel(response)
      return pouchModel
    } catch {
      return { error: true }
    }
  }
  async getDriverPouchByDriverId(driverId: number): Promise<DriverPouchEntity | { error: true }> {
    try {
      const response = await PouchesService.getDriverPouchByDriverAdmin({
        driverId
      })
      const pouchModel = new DriverPouchModel(response)
      return pouchModel
    } catch {
      return { error: true }
    }
  }
  async putDriverPouch(
    id: number,
    maxAmountLimit: number
  ): Promise<DriverPouchEntity | { error: true }> {
    try {
      const response = await PouchesService.putDriverPouchMaxLimitAmountAdmin({
        id,
        requestBody: {
          maxAmountLimit
        }
      })
      const pouchModel = new DriverPouchModel(response)
      return pouchModel
    } catch {
      return { error: true }
    }
  }
  async getAccountantPouches(
    filterData: PouchFilterEntity
  ): Promise<PaginateEntity<AccountantPouchMiniEntity[]> | { error: true }> {
    const pouchFilterModel = new PouchFilterModel(filterData)
    try {
      const response = await PouchesService.getAccountantPouchesAdmin(pouchFilterModel as {})
      const pouchModel = response.items?.map((item) => new AccountantPouchMiniModel(item))
      const result = new PaginateEntity<AccountantPouchMiniModel[]>(response, pouchModel)
      return result
    } catch {
      return { error: true }
    }
  }
  async exportAccountantPouch(filterData: PouchFilterEntity): Promise<Blob | null | undefined> {
    const pouchFilterModel = new PouchFilterModel(filterData)
    try {
      const response = await PouchesService.exportAccountantPouchFilesAdmin(pouchFilterModel as {})
      return response.file
    } catch {
      return null
    }
  }
  async getAccountantPouch(id: number): Promise<AccountantPouchEntity | { error: true }> {
    try {
      const response = await PouchesService.getAccountantPouchAdmin({
        id
      })
      const pouchModel = new AccountantPouchModel(response)
      return pouchModel
    } catch {
      return { error: true }
    }
  }

  async getCurrentAccountant(): Promise<boolean | { error: true }> {
    try {
      const response = await PouchesService.getCurrentUserAccountantPouchCheckAdmin()
      return response.isAccountant ?? false
    } catch {
      return { error: true }
    }
  }
  async getDriverHalts(
    filterData: DriverHaltsFilterEntity
  ): Promise<PaginateEntity<DriverHaltEntity[]> | { error: true }> {
    const driverHaltsFilterModel = new DriverHaltsFilterModel(filterData)
    try {
      const response = await DriverHaltsService.getDriverHaltsAdmin(driverHaltsFilterModel)
      const driverHaltModel = response.items?.map((item) => new DriverHaltModel(item))
      const result = new PaginateEntity<DriverHaltModel[]>(response, driverHaltModel)
      return result
    } catch {
      return { error: true }
    }
  }
  async haltDriver(driverId: number): Promise<{ success: true } | { error: true }> {
    try {
      await DriverHaltsService.postDriverHaltAdmin({
        driverId
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async removeHaltDriver(driverId: number): Promise<{ success: true } | { error: true }> {
    try {
      await DriverHaltsService.postDriverHaltReleaseAdmin({
        driverId
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
